import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@src/app/services/user-managment/authentication/authentication.service';
import { OTP_STATUS } from '../../constant/statuses';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  @ViewChildren('otpInput') inputs!: QueryList<ElementRef<HTMLInputElement>>;

  otpForm: FormGroup;
  activeInput = 0;
  error = false;
  subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public translate: TranslateService,
    public authService: AuthService
  ) {
    this.otpForm = this.fb.group({
      code: this.fb.array(Array(6).fill('').map(() => new FormControl('')))
    });
  }

  get codeControls() {
    return (this.otpForm.get('code') as FormArray).controls;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.authService.notify.subscribe({
        next: (status) => {
          if (status === OTP_STATUS.success) {
            this.router.navigate(['/']);
          } else {
            this.error = true;
            this.otpForm.reset();
            this.activeInput = 0;
          }
        }
      })
    );
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const digit = input.value.replace(/\D/g, '').charAt(0);
    if (!digit) return;

    this.codeControls[index].setValue(digit, { emitEvent: false });

    if (index < this.codeControls.length - 1) {
      this.inputs.toArray()[index + 1].nativeElement.focus();
    }

    const fullOtp = this.codeControls.map(c => c.value).join('');
    if (fullOtp.length === 6 && this.codeControls.every(c => c.value !== '')) {
      this.authService.otpSubmit(fullOtp);
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !this.codeControls[index].value && index > 0) {
      this.inputs.toArray()[index - 1].nativeElement.focus();
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = event.clipboardData?.getData('text') || '';
    const digits = text.replace(/\D/g, '').slice(0, this.codeControls.length);

    digits.split('').forEach((digit, i) => {
      this.codeControls[i].setValue(digit, { emitEvent: false });
    });

    const lastIdx = digits.length - 1;
    this.inputs.toArray()[lastIdx]?.nativeElement.focus();

    const fullOtp = this.codeControls.map(c => c.value).join('');
    if (fullOtp.length === 6 && this.codeControls.every(c => c.value !== '')) {
      this.authService.otpSubmit(fullOtp);
    }
  }


}
